<template>
    <div>
				<h1>Заявки на удаление проектов</h1>
        <Table
                :data-source="projects"
                :columns="columns"
                :loading="isLoading"
        >
            <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'name'">
                    <a target="_blank" :href="'/project/to_expert_project/' + record.id">{{ record.name }}</a>
                </template>
                <template v-if="column.key === 'actions'">
										<a @click.prevent="deleteProject(record.id)">Удалить</a>
                </template>
            </template>
        </Table>

    </div>
</template>

<script setup>
import {ref} from "vue";
import axios from "axios";
import {Table} from "ant-design-vue"

let projects = ref([]);
const columns = ref([
  {
    title: 'Название',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Действия',
    dataIndex: 'actions',
    key: 'actions',
  }
]);
let isLoading = ref(false);


async function getData() {
  const response = await axios.get('/project/get_projects_to_delete');
  projects.value = response.data;
}

getData();

async function deleteProject(id) {
  const response = await axios.get('/project/delete_full/' + id);
  if (response.data !== 'ok') {
    alert(response.data);
  } else {
    getData();
  }
}

</script>

<style scoped>

</style>